import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Capture PWA install prompt globally so any screen (e.g. Me page) can offer install/reinstall.
window.__deferredInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event("pwa-installable"));
});
window.addEventListener("appinstalled", () => {
  window.__deferredInstallPrompt = null;
  window.dispatchEvent(new Event("pwa-installed"));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      const watch = (w) => w && w.addEventListener("statechange", () => { if (w.state === "installed" && navigator.serviceWorker.controller) window.dispatchEvent(new Event("pwa-update-available")); });
      if (reg.waiting && navigator.serviceWorker.controller) window.dispatchEvent(new Event("pwa-update-available"));
      watch(reg.installing);
      reg.addEventListener("updatefound", () => watch(reg.installing));
      const check = () => { reg.update().catch(() => {}); checkBuild(); };
      setInterval(check, 10 * 60 * 1000);
      document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
      checkBuild();
    }).catch(() => {});
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => { if (window.__pwaReloadOnControl && !reloaded) { reloaded = true; window.location.reload(); } });
  });
}

// Stale-build guard: after a deploy the cached app shell may still point at the OLD bundle on slow networks.
// Compare the bundle we are running with the server's asset-manifest; if it differs, drop caches and reload once.
async function checkBuild() {
  try {
    const running = [...document.scripts].map((s) => s.src).find((u) => /\/static\/js\/main\.[a-z0-9]+\.js/.test(u));
    if (!running) return;
    const r = await fetch("/asset-manifest.json", { cache: "no-store" });
    if (!r.ok) return;
    const m = await r.json();
    const latest = m && m.files && m.files["main.js"];
    if (!latest) return;
    const latestFile = latest.split("/").pop(); const runningFile = running.split("/").pop();
    window.__buildId = latestFile.replace(/^main\.|\.js$/g, "");
    if (latestFile !== runningFile && !sessionStorage.getItem("rl_build_reload")) {
      sessionStorage.setItem("rl_build_reload", latestFile);
      if (window.caches) { const ks = await caches.keys(); await Promise.all(ks.filter((k) => k !== "royal-laxmi-shared-receipt").map((k) => caches.delete(k))); }
      window.location.reload();
    }
  } catch { /* offline — keep the cached shell */ }
}
